import React from 'react'

export default function CircleBg (props) {
  const percent = parseFloat(props.percent)
  const size = 272
  const radius = size / 2
  const circum = 2 * radius * Math.PI
  const draw = percent * circum / 100
  const dashArray = `${draw}, 900`
  const bgDash = '900, 900'

  return (
    <svg className='mtt-ttmzero-circle__svg' viewBox='0 0 304 304' width='304' height='304'>
      <defs>
        <linearGradient id='linear' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#4E52C1' />
          <stop offset='100%' stopColor='#A664EC' />
        </linearGradient>
      </defs>
      <circle
        className='mtt-ttmzero-circle__svg-circle-border'
        r={radius}
        cx={radius + 16}
        cy={radius + 16}
        strokeDasharray={bgDash}
        stroke='#fff'
        opacity='0.1'
      />
      <circle
        className='mtt-ttmzero-circle__svg-circle'
        r={radius}
        cx={radius + 16}
        cy={radius + 16}
        strokeDasharray={dashArray}
        stroke='url(#linear)'
      />
    </svg>
  )
}
